import { formatPrice } from '@witmetrics/utils/strings';
import { getOrderTotals } from '@/utils/pricing';
import { usePath } from '@/hooks/usePath';
import { useCheckout } from '@/providers/CheckoutProvider';
import { useShopProduct } from '@/hooks/useShopProduct';
import { PAGES } from '@/constants/pages';
import Button from '@/components/Button';
import ConsentGate from '@/components/ConsentGate';
import OrderTotals from '@/components/OrderTotals';
import QuantityStepper from '@/components/QuantityStepper';
import StripeNote from '@/components/StripeNote';
import Card from '@/components/Card';
import { classes } from './utils';

export interface OrderCardProps {
  className?: string;
}

export default function OrderCard({ className }: OrderCardProps) {
  const { navigate } = usePath();
  const {
    acceptsTerms,
    isProfessional,
    quantity,
    setQuantity,
    toggleProfessional,
    toggleTerms,
  } = useCheckout();
  const { currency, unitPrice } = useShopProduct();

  const totals = getOrderTotals(quantity, unitPrice);
  const isConsentGiven = isProfessional && acceptsTerms;

  return (
    <Card className={className}>
      <div className={classes.priceRow}>
        <span className={classes.price}>
          {formatPrice(unitPrice, currency)}
        </span>
        <span className={classes.priceNote}>per bottle, excl. VAT</span>
      </div>
      <div className={classes.quantityRow}>
        <span className={classes.quantityLabel}>Bottles</span>
        <QuantityStepper
          label="Bottles"
          value={quantity}
          onChange={setQuantity}
        />
      </div>
      <OrderTotals
        className={classes.totals}
        currency={currency}
        totals={totals}
      />
      <ConsentGate
        acceptsTerms={acceptsTerms}
        isProfessional={isProfessional}
        className={classes.consent}
        onToggleProfessional={toggleProfessional}
        onToggleTerms={toggleTerms}
      />
      <Button
        disabled={!isConsentGiven}
        className={classes.cta}
        onClick={() => navigate(PAGES.CHECKOUT)}>
        Buy now
      </Button>
      <StripeNote className={classes.stripe} />
    </Card>
  );
}
